const bundleSubDirectory = "/bundle";

export const getAllActiveBundles = `${bundleSubDirectory}/getAllActiveBundles`;
